export enum CrudStoreItem {
  SalesTeamCoverage = 'SalesTeamCoverage',
  SalesTeamRequests = 'SalesTeamRequests',
  HPContacts = 'HPContacts',
  PartnerAllData = 'PartnerAllData',
  PartnerMissedContacts = 'PartnerMissedContacts',
  PromosCustomerInfo = 'PromosCustomerInfo',
  PartnerTree = 'PartnerTree',
  PartnerBranchesCount = 'PartnerBranchesCount',
  FavoritePartners = 'JBPMyPartners',
  PartnersSearch = 'PartnersSearch',
  PartnersSearchFilteredByCode = 'PartnersSearchFilteredByCode',
  PartnerActualData = 'PartnerActualData',
  OpenedPartnerRequests = 'OpenedPartnerRequests',
  LegalPartnerRequests = 'LegalPartnerRequests',
  ContactCodeRequests = 'ContactCodeRequests',
  NewPartners = 'NewPartners',
  WW_ContactCampaigns = 'WW_ContactCampaigns',
  CodesDictionary = 'CodesDictionary',
  CodesDictionaryByCodeName = 'CodesDictionaryByCodeName',
  CodesDictionaryByCode = 'CodesDictionaryByCode',
  WW_UserToolsAccess = 'WW_UserToolsAccess',
  WW_UserRights = 'WW_UserRights',
  ContactAllData = 'ContactAllData',
  OpenedContactRequests = 'OpenedContactRequests',
  ContactExt = 'ContactExt',
  ContactExtData = 'ContactExtData',
  CallOutcome = 'CallOutcome',
  PushDayOutcome = 'PushDayOutcome',
  PartnerFlagsRequests = 'PartnerFlagsRequests',
  ValidationRules = 'ValidationRules',
  SalesTeamTickets = 'SalesTeamTickets',
  SearchAPIPartner = 'SearchAPIPartner',
  SearchAPIContact = 'SearchAPIContact',
  CountryProvinceNames = 'CountryProvinceNames',
  PreferredContacts = 'PreferredContacts',
  SWOT_Analysis = 'SWOT_Analysis',
  PartnerLandscape = 'PartnerLandscape',
  LeadAbout = 'LeadAbout',
  PartyDetailReport = 'PartyDetailReport',
  AgreementReport = 'agreement_report',
  LegalAttachments = 'LegalAttachments',
  CampaignAttachments = 'cng-campaign-attachments',
  CampaignReminders = 'cng-campaign-reminders',
  ToDoWidgetData = 'ToDoWidgetData',
  ToDoWidgetDataLogs = 'ToDoWidgetDataLogs',
  AutoCheckStatistic = 'AutoCheckStatistic',
  AutoCheckCalculateStats = 'AutoCheckCalculateStats',
  PartnerAdditionalInfo = 'PartnerAdditionalInfo',
  PolyPartnerList = 'PolyPartnerList',
  LNDRForm = 'LNDRForm',

  PFE_StatusOverall = 'PFE_StatusOverall',
  PFE_StatusAccred = 'PFE_StatusAccred',
  PFE_StatusRevenue = 'PFE_StatusRevenue',
  PFE_StatusCertification = 'PFE_StatusCertification',
  PFE_StatusCertEmp = 'PFE_StatusCertEmp',
  PFE_CertDisplayname = 'PFE_CertDisplayname',
  PFE_StatusOther = 'PFE_StatusOther',

  PartnerLog = 'PartnerLog',
  PartnerLegalExtendLog = 'PartnerLegalExtendLog',
  PartnerCodeLog = 'PartnerCodeLog',
  ContactCodeLog = 'ContactCodeLog',
  ContactsLog = 'ContactsLog',
  LocatorLog = 'LocatorLog',
  NegotiableHistory = 'NegotiableHistory',
  CnGMaintenanceInfo = 'CnGMaintenanceInfo',

  Comments = 'Comments',
  MyCoverage = 'MyCoverage',
  PartnerToDoFlags = 'PartnerToDoFlags',
  SearchResultPartners = 'SearchResultPartners',
  CampaignPartnerAssignment = 'CampaignPartnerAssignment',
  ListCampaigns = 'ListCampaigns',
  CSISummaryInfoUser = 'CSISummaryInfoUser',
  RegistraionForm = 'RegistraionForm',
  Reg_Dashboard = 'Reg_Dashboard',
  SecurimatePartners = 'SecurimatePartners',
  ThirdPartyType = 'ThirdPartyType',
  SecurimatePartnersFetch = 'SecurimatePartnersFetch',
  PartnerRequestProfiling = 'PartnerRequestProfiling',
  ContactRequestProfiling = 'ContactRequestProfiling',
  ProfilingTicket = 'ProfilingTicket',
  TicketChanges = 'TicketChanges',
  PartnerONBBusinessDetails = 'PartnerONBBusinessDetails',
  PartnerBusinessDetails = 'PartnerBusinessDetails',
  PartnerSuppliesPricingFlags = 'PartnerSuppliesPricingFlags',
  PartnerInactiveWithAuditFlags = 'PartnerInactiveWithAuditFlags',

  SustainabilityPlan = 'SustainabilityPlan',
  SustainabilityPlanItems = 'SustainabilityPlanItems',
  ImpactPledge = 'ImpactPledge',
  ImpactPledge22 = 'ImpactPledge22',
  ImpactAssessment = 'ImpactAssessment',
  ImpactAssessment22 = 'ImpactAssessment22',
  SustainabilityActivityLogs = 'SustainabilityActivityLogs',
  SustainabilityAttachments = 'SustainabilityAttachments',
  SustainabilityAttachments24 = 'SustainabilityAttachments24',
  SustainabilityAttachments24Table = 'SustainabilityAttachments24Table',

  ExecutiveSponsorshipFormM01 = 'ExecutiveSponsorshipFormM01',
  ExecutiveSponsorshipFormM0124 = 'ExecutiveSponsorshipFormM0124',
  SustainableProcurementM02 = 'SustainableProcurementM02',
  SustainableProcurementM0224 = 'SustainableProcurementM0224',
  SustainabilityDealFormM07 = 'SustainabilityDealFormM07',
  SustainabilityDealFormM0724 = 'SustainabilityDealFormM0724',
  CommunicationsReportingFormM05 = 'CommunicationsReportingFormM05',
  CommunicationsReportingFormM0524 = 'CommunicationsReportingFormM0524',
  PrintFleetAssessmentM09 = 'PrintFleetAssessmentM09',
  PrintFleetAssessmentM0924 = 'PrintFleetAssessmentM0924',
  CustomerAwarenessFormM11 = 'CustomerAwarenessFormM11',
  MarketingCampaignFormM111 = 'MarketingCampaignFormM111',
  MarketingCampaignFormM11124 = 'MarketingCampaignFormM11124',
  CustomerAwarenessFormM1124 = 'CustomerAwarenessFormM1124',
  SyndicatedContentFormM11224 = 'SyndicatedContentFormM11224',
  OfficeRecyclingFormM14 = 'OfficeRecyclingFormM14',
  OfficeRecyclingFormM1424 = 'OfficeRecyclingFormM1424',
  CarbonFootprintActionM15 = 'CarbonFootprintActionM15',
  CarbonFootprintActionM1524 = 'CarbonFootprintActionM1524',
  EnergyEfficiencyFormM16 = 'EnergyEfficiencyFormM16',
  EnergyEfficiencyFormM1624 = 'EnergyEfficiencyFormM1624',
  EmployeeWellBeingFormM21 = 'EmployeeWellBeingFormM21',
  EmployeeWellBeingFormM2124 = 'EmployeeWellBeingFormM2124',
  VolunteeringFormM22 = 'VolunteeringFormM22',
  VolunteeringFormM2224 = 'VolunteeringFormM2224',
  CommunityEngagementFormM24 = 'CommunityEngagementFormM24',
  CommunityEngagementFormM2424 = 'CommunityEngagementFormM2424',
  UserInitiativesForm = 'UserInitiativesForm',
  UserInitiativesForm24 = 'UserInitiativesForm24',
  DEIStrategyFormM18 = 'DEIStrategyFormM18',
  DEIStrategyFormM1824 = 'DEIStrategyFormM1824',
  CustomerCaseStudiesM10 = 'CustomerCaseStudiesM10',
  CustomerCaseStudiesM1024 = 'CustomerCaseStudiesM1024',
  SustainabilityFormM13 = 'SustainabilityFormM13',
  SustainabilityFormM1324 = 'SustainabilityFormM1324',
  VisionFormM25 = 'VisionFormM25',
  EWasteFormM30 = 'EWasteFormM30',
  OnlineBrandingFormM31 = 'OnlineBrandingFormM31',
  OnlineBrandingFormM38 = 'OnlineBrandingFormM38',

  SalesTeamLogs = 'SalesTeamLogs',
  SalesTeamRecordLogs = 'SalesTeamRecordLogs',
  SalesTeamMngm = 'SalesTeamMngm',
  SalesTeamSRM = 'SalesTeamSRM',
  SalesTeamRollDown = 'SalesTeamRollDown',
  BPOverviewSalesAgent = 'BPOverviewSalesAgent',
  ToolAccessPartnerFlags = 'ToolAccessPartnerFlags',
  AmplifyinsightRequests = 'AmplifyinsightRequests',
  AmplifyInsightNames = 'AmplifyInsightNames',
  AmplifyInsightApprovers = 'AmplifyInsightApprovers',
  AmplifyInsightRequestDetails = 'AmplifyInsightRequestDetails',
  AmplifyInsightExport = 'AmplifyInsightExport',
  ProfilingTicketsMentionedUsers = 'ProfilingTicketsMentionedUsers',
  ProfilingAudience = 'ProfilingAudience',
  ContactActualData = 'ContactActualData',
  WW_Contacts = 'WW_Contacts',
  WW_Partners = 'WW_Partners',
  WW_PartnersList = 'WW_PartnersList',
  ContactAdditionalInfo = 'ContactAdditionalInfo',
  PartnerDrafts = 'PartnerDrafts',
  ContactFlags = 'ContactFlags',
  ContactFlagRequests = 'ContactFlagRequests',
  ContactFlagsAllData = 'contact_flags_all_data',
  ToolAccessConditions = 'toolaccessconditions-935',
  ToolsCodeRules = 'flagtranslations-2070',
  CnGPartnerDataChange = 'CnGPartnerDataChange',
  CnGPartnerFlagsDataChange = 'CnGPartnerFlagsDataChange',
  CnGContactsDataChange = 'CnGContactsDataChange',
  CnGContactFlagsDataChange = 'CnGContactFlagsDataChange',

  MDMAutoFlaggingRules = 'mdm-autoflagging-rules',

  PartnerContacts = 'partner-contacts-v2',

  BusinessOpportunityFinder = 'BusinessOpportunityFinder',
  BOF_leadPBM_list = 'BOF_leadPBM_list',
  BOF_partners_list = 'BOF_partners_list',
  BOF_industry_list = 'BOF_industry_list',

  CatalystList = 'CatalystList',
  CatalystList24 = 'CatalystList24',
  CatalystList25 = 'CatalystList25',
  CatalystListDetail = 'CatalystListDetail',
  CatalystListDetailFY24 = 'CatalystListDetailFY24',
  AdminHubM02 = 'AdminHubM02',
  AdminHubM07 = 'AdminHubM07',
  AdminHubM09 = 'AdminHubM09',
  AdminHubM11_1 = 'AdminHubM11_1',
  AdminHubM10 = 'AdminHubM10',
  AdminHubM22 = 'AdminHubM22',
  AdminHubM24 = 'AdminHubM24',
  AdminHubM18 = 'AdminHubM18',
  AdminHubM15 = 'AdminHubM15',
  AdminHubM13 = 'AdminHubM13',
  AdminHubM21 = 'AdminHubM21',
  AdminHubM16 = 'AdminHubM16',
  AdminHubM14 = 'AdminHubM14',
  AdminHubM05 = 'AdminHubM05',
  AdminHubM01 = 'AdminHubM01',
  ImpactAssessment1228 = 'ImpactAssessment1228',
  ImpactAssessment1416 = 'ImpactAssessment1416',
  SyndicationShowCaseReport = 'SyndicationShowCaseReport',
  PlanetPartnerApproval = 'PlanetPartnerApproval',

  SustainabilityPlan23 = 'SustainabilityPlan23',
  SustainabilityPlan24 = 'SustainabilityPlan24',
  SustainabilityPlan25 = 'SustainabilityPlan25',
  SustainabilityPlanItems23 = 'SustainabilityPlanItems23',
  SustainabilityPlanItems24 = 'SustainabilityPlanItems24',
  SustainabilityPlanItems25 = 'SustainabilityPlanItems25',
  JBPMasterDealers = 'JBPMasterDealers',
  JBPMasterDealerData = 'JBPMasterDealerData',
  JBPMasterDealerExtendedPartners = 'JBPMasterDealerExtendedPartners',
  JBPMasterDealerRelateToExtendedPartner = 'JBPMasterDealerRelateToExtendedPartner',
  JBPMasterDealerEPAssignedToNonCompliantMD = 'JBPMasterDealerEPAssignedToNonCompliantMD',

  PartnerLnRStatuses = 'PartnerLnRStatuses',

  DistributorsOnBehalfList = 'DistributorsOnBehalfList',

  Roles = 'Roles',
  FormCollector = 'FormCollector',
  UsersView = 'UsersView',
  AppUsersAppsSearch = 'AppUsersAppsSearch',
  CountriesTable = 'CountriesTable',
  ExcelMapping = 'ExcelMapping',
  ExcelCellFormat = 'ExcelCellFormat',
  CountryStatesDropdown = 'CountryStatesDropdown',
  WW_REF_ID = 'WW_REF_ID',
  PartnerRefIDs = 'PartnerRefIDs',
  PartnerRefIDsRequests = 'PartnerRefIDsRequests',
  AppNotifications = 'AppNotifications',
  OrganizationChart = 'OrganizationChart',
  EngagementPrediction = 'engagement-predictions',
  MDAdditionalInfo = 'master-dealer-additional',

  CallLogs = 'CallLogs',
}
